import vaultAbi from "./Deposit.json";

export const VaultAbi = vaultAbi;
